var SENTRY_RELEASE;SENTRY_RELEASE={name: "L21st Flare", version: "1.10"};